export function mantenerSoloNumeros(texto: string) {
    return texto.replace(/[^0-9]/g, '');
}

export function formatearTelefono(texto: string) {
    const soloNumeros = mantenerSoloNumeros(texto);
    const solo8Caracteres = soloNumeros.slice(0, 8);
    return solo8Caracteres.replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Telefonos/utils/formateadores.ts